import { createSlice } from "@reduxjs/toolkit";
import { IAgentPolicyMetricsSlice } from "../../../models/agent/policiesListing";
import { GetPolicyMetrics } from "./PolicyMetricsAction";

const initialState: IAgentPolicyMetricsSlice = {
  totalPolicies: null,
  activePolicies: null,
  cancelNoticePolicies: null,
  cancelledPolicies: null,
  renewalInprogressPolicies: null,
  nonRenewRequestedPolicies: null,
  nonPayCancelledPolicies: null,
  futureExpiredPolicies:null
};

const AgentPolicyMetricsSlice = createSlice({
  name: "agentPolicyMetrics",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetPolicyMetrics.fulfilled, (state, { payload }) => {
      if (payload.status === "SUCCESS") {
        state.totalPolicies = payload.data ? payload.data.totalPolicies : null;
        state.activePolicies = payload.data
          ? payload.data.activePolicies
          : null;
        state.cancelNoticePolicies = payload.data
          ? payload.data.cancelNoticePolicies
          : null;
        state.cancelledPolicies = payload.data
          ? payload.data.cancelledPolicies
          : null;
        state.renewalInprogressPolicies = payload.data
          ? payload.data.renewalInprogressPolicies
          : null;
        state.nonRenewRequestedPolicies = payload.data
          ? payload.data.nonRenewRequestedPolicies
          : null;
        state.nonPayCancelledPolicies = payload.data
          ? payload.data.nonPayCancelledPolicies
          : null;
          state.futureExpiredPolicies = payload.data
          ? payload.data.futureExpiredPolicies
          : null;  
      }
    });
  },
});

export default AgentPolicyMetricsSlice.reducer;
